import {inject, Injectable}              from '@angular/core';
import {Timestamp}                       from '@angular/fire/firestore';
import {MindPsycType, MindRecordLogIntf} from '@djsharkk/logr-types';
import {AuthUnlockService}               from '../../../../../../../logr-auth/utils/auth-unlock.service';
import {MenuCrudPanelToggleBase}         from '../../menu-crud-panel-toggle-base';

@Injectable({
				providedIn: 'root'
			})
export class MenuCrudPanelMindService extends MenuCrudPanelToggleBase<MindPsycType> {
	svcAuthUnlock = inject(AuthUnlockService)

	selected: MindPsycType[] = [];
	note: string = '';


	constructor() {
		super('mind')
	}

	async addRecord() {
		const note = await this.svcAuthUnlock.encrypt(this.note);
		const mind = await Promise.all(this.selected.map(async (s) => {
			return this.svcAuthUnlock.encrypt(s);
		})) as MindPsycType[];
		const record: MindRecordLogIntf = {
			timestamp: Timestamp.now(),
			mind,
			note
		};
		this.svcDataFactory.svcDataMind.createRecord(record)
	}

}
